/* eslint-disable react/prop-types */
import { Button } from 'antd';
import { PRODUCT_NAME } from '@/constants';
import { Link } from 'react-router-dom';
import classes from './index.module.css';

const getTitle = (name) => `Offer ${name === 'Shopify' ? PRODUCT_NAME.WORRY_FREE_PURCHASE : PRODUCT_NAME.GREEN_SHIPPING_PROTECTION} that earns customer trust and loyalty.`;
const descMap = ['Protect orders against loss, damage, and delay', 'Eliminate shipping related customer complaints', 'Turn late deliveries into repeat customers'];

export default function Intro({ name }) {
  return (
    <div className={classes.intro}>
      <div className={classes.title}>
        {getTitle(name)}
      </div>
      <ul className={classes.desc}>
        {descMap.map((desc) => <li key={desc} className={classes.desc_item}>{desc}</li>)}
        <li><a href="https://kover2618.zendesk.com/hc/en-us/articles/17571948690587-Learn-more-about-Green-Shipping-Protection" target="_blank" rel="noreferrer">{'How does it work for Shopify merchants >'}</a></li>
      </ul>
      <Link to="./fulfillment">
        <Button
          type="primary"
          className={classes.next_button}
          htmlType="submit"
        >
          Get Started
        </Button>
      </Link>
    </div>

  );
}
